import * as React from "react";

const SVGComponent = ({
    // style = {},
    fill = "currentColor",
    width = "100%",
    height = "100%",
    className = "",
}) => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 492.1 122.1"
        xmlSpace="preserve"
        className={className || ""}
        width={width}
        // style={style}
        height={height}
    >
        <g>
            <defs>
                <rect id="SVGID_1_" width={133.6} height={122.1} />
            </defs>
            <g>
                <defs>
                    <path
                        id="SVGID_00000146486572770842274240000009824894385840816525_"
                        d="M104.4,14c0,0-0.5,44.7-5.3,60c0,0,0,0.1,0,0.1 c-2.5,8.7-10.6,17.3-21.9,22c-16.9,7-34.7,2.9-39.7-9.1c-5-12,4.6-27.5,21.4-34.5c14.1-5.9,28.8-3.9,36.2,3.9 c1.2-19.4-1-41.5-3.1-56.4L12.7,19.6c-9.9,2.7-13.5,9-12.2,17.7l12.2,65c0,0.9,0.1,1.7,0.3,2.6c0.2,0.8,0.4,1.7,0.8,2.5 c0.3,0.8,0.7,1.6,1.2,2.3c0.5,0.7,1,1.4,1.7,2c0.6,0.6,1.3,1.2,2,1.6c0.7,0.5,1.5,0.9,2.3,1.2c0.8,0.3,1.6,0.6,2.5,0.8 c0.9,0.2,1.7,0.3,2.6,0.3l84.2,6.6c0.9,0,1.7-0.1,2.6-0.3c0.9-0.2,1.7-0.4,2.5-0.8c0.8-0.3,1.6-0.7,2.3-1.2c0.7-0.5,1.4-1,2-1.6 c0.6-0.6,1.2-1.3,1.7-2c0.5-0.7,0.9-1.5,1.2-2.3c0.3-0.8,0.6-1.6,0.8-2.5c0.2-0.8,0.3-1.7,0.3-2.6l9.9-102.5c0-0.5,0-1-0.1-1.5 C125.4,9.9,104.4,14,104.4,14z"
                    />
                </defs>
                <clipPath id="SVGID_00000021815964120865188200000008148856302729085087_">
                    <use
                        xlinkHref="#SVGID_00000146486572770842274240000009824894385840816525_"
                        style={{
                            overflow: "visible",
                        }}
                    />
                </clipPath>
                <g style={{ clipPath: "url(#SVGID_00000021815964120865188200000008148856302729085087_)" }} >
                    <linearGradient
                        id="SVGID_00000121238017043144745250000008116791160412006079_"
                        gradientUnits="userSpaceOnUse"
                        x1={-118.6169}
                        y1={358.6853}
                        x2={-11.6037}
                        y2={278.423}
                        gradientTransform="matrix(1.3478 0 0 -1.3418 154.4732 488.5296)"
                    >
                        <stop offset={0} style={{ stopColor: "#FFBD59" }} />
                        <stop offset={0.0625} style={{ stopColor: "#FFBD59" }} />
                        <stop offset={0.09375} style={{ stopColor: "#FFBD59" }} />
                        <stop offset={0.1016} style={{ stopColor: "#FFBD59" }} />
                        <stop offset={0.1055} style={{ stopColor: "#FFBB57" }} />
                        <stop offset={0.1094} style={{ stopColor: "#FFB956" }} />
                        <stop offset={0.1133} style={{ stopColor: "#FFB754" }} />
                        <stop offset={0.1172} style={{ stopColor: "#FFB553" }} />
                        <stop offset={0.1211} style={{ stopColor: "#FFB451" }} />
                        <stop offset={0.125} style={{ stopColor: "#FFB24F" }} />
                        <stop offset={0.1289} style={{ stopColor: "#FFB04E" }} />
                        <stop offset={0.1328} style={{ stopColor: "#FFAE4C" }} />
                        <stop offset={0.1367} style={{ stopColor: "#FFAC4B" }} />
                        <stop offset={0.1406} style={{ stopColor: "#FFAA49" }} />
                        <stop offset={0.1445} style={{ stopColor: "#FFA848" }} />
                        <stop offset={0.1484} style={{ stopColor: "#FFA746" }} />
                        <stop offset={0.1523} style={{ stopColor: "#FFA545" }} />
                        <stop offset={0.1562} style={{ stopColor: "#FFA343" }} />
                        <stop offset={0.1602} style={{ stopColor: "#FFA141" }} />
                        <stop offset={0.1641} style={{ stopColor: "#FF9F40" }} />
                        <stop offset={0.168} style={{ stopColor: "#FF9D3E" }} />
                        <stop offset={0.1719} style={{ stopColor: "#FF9B3D" }} />
                        <stop offset={0.1758} style={{ stopColor: "#FF9A3B" }} />
                        <stop offset={0.1797} style={{ stopColor: "#FF983A" }} />
                        <stop offset={0.1836} style={{ stopColor: "#FF9638" }} />
                        <stop offset={0.1875} style={{ stopColor: "#FF9436" }} />
                        <stop offset={0.1914} style={{ stopColor: "#FF9235" }} />
                        <stop offset={0.1953} style={{ stopColor: "#FF9033" }} />
                        <stop offset={0.1992} style={{ stopColor: "#FF8F32" }} />
                        <stop offset={0.2031} style={{ stopColor: "#FF8D30" }} />
                        <stop offset={0.207} style={{ stopColor: "#FF8B2F" }} />
                        <stop offset={0.2109} style={{ stopColor: "#FF892D" }} />
                        <stop offset={0.2148} style={{ stopColor: "#FF872C" }} />
                        <stop offset={0.2188} style={{ stopColor: "#FF852A" }} />
                        <stop offset={0.2227} style={{ stopColor: "#FF8328" }} />
                        <stop offset={0.2266} style={{ stopColor: "#FF8227" }} />
                        <stop offset={0.2305} style={{ stopColor: "#FF8025" }} />
                        <stop offset={0.2344} style={{ stopColor: "#FF7E24" }} />
                        <stop offset={0.2383} style={{ stopColor: "#FF7C22" }} />
                        <stop offset={0.2422} style={{ stopColor: "#FF7A21" }} />
                        <stop offset={0.2461} style={{ stopColor: "#FF781F" }} />
                        <stop offset={0.25} style={{ stopColor: "#FF761D" }} />
                        <stop offset={0.2539} style={{ stopColor: "#FF751C" }} />
                        <stop offset={0.2578} style={{ stopColor: "#FF731A" }} />
                        <stop offset={0.2617} style={{ stopColor: "#FF7119" }} />
                        <stop offset={0.2656} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.2812} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.3125} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.375} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.408} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.5} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.5625} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.592} style={{ stopColor: "#FF7018" }} />
                        <stop offset={0.5938} style={{ stopColor: "#FF7119" }} />
                        <stop offset={0.5977} style={{ stopColor: "#FF7219" }} />
                        <stop offset={0.6016} style={{ stopColor: "#FF731A" }} />
                        <stop offset={0.6055} style={{ stopColor: "#FF731A" }} />
                        <stop offset={0.6094} style={{ stopColor: "#FF741A" }} />
                        <stop offset={0.6133} style={{ stopColor: "#FF751B" }} />
                        <stop offset={0.6172} style={{ stopColor: "#FF761B" }} />
                        <stop offset={0.6211} style={{ stopColor: "#FF771C" }} />
                        <stop offset={0.625} style={{ stopColor: "#FF771C" }} />
                        <stop offset={0.6289} style={{ stopColor: "#FF781D" }} />
                        <stop offset={0.6328} style={{ stopColor: "#FF791D" }} />
                        <stop offset={0.6367} style={{ stopColor: "#FF7A1E" }} />
                        <stop offset={0.6406} style={{ stopColor: "#FF7B1E" }} />
                        <stop offset={0.6445} style={{ stopColor: "#FF7C1F" }} />
                        <stop offset={0.6484} style={{ stopColor: "#FF7C1F" }} />
                        <stop offset={0.6523} style={{ stopColor: "#FF7D20" }} />
                        <stop offset={0.6562} style={{ stopColor: "#FF7E20" }} />
                        <stop offset={0.6602} style={{ stopColor: "#FF7F21" }} />
                        <stop offset={0.6641} style={{ stopColor: "#FF8021" }} />
                        <stop offset={0.668} style={{ stopColor: "#FF8022" }} />
                        <stop offset={0.6719} style={{ stopColor: "#FF8122" }} />
                        <stop offset={0.6758} style={{ stopColor: "#FF8223" }} />
                        <stop offset={0.6797} style={{ stopColor: "#FF8323" }} />
                        <stop offset={0.6836} style={{ stopColor: "#FF8424" }} />
                        <stop offset={0.6875} style={{ stopColor: "#FF8424" }} />
                        <stop offset={0.6914} style={{ stopColor: "#FF8525" }} />
                        <stop offset={0.6953} style={{ stopColor: "#FF8625" }} />
                        <stop offset={0.6992} style={{ stopColor: "#FF8726" }} />
                        <stop offset={0.7031} style={{ stopColor: "#FF8826" }} />
                        <stop offset={0.707} style={{ stopColor: "#FF8926" }} />
                        <stop offset={0.7109} style={{ stopColor: "#FF8927" }} />
                        <stop offset={0.7148} style={{ stopColor: "#FF8A27" }} />
                        <stop offset={0.7188} style={{ stopColor: "#FF8B28" }} />
                        <stop offset={0.7227} style={{ stopColor: "#FF8C28" }} />
                        <stop offset={0.7266} style={{ stopColor: "#FF8D29" }} />
                        <stop offset={0.7305} style={{ stopColor: "#FF8D29" }} />
                        <stop offset={0.7344} style={{ stopColor: "#FF8E2A" }} />
                        <stop offset={0.7383} style={{ stopColor: "#FF8F2A" }} />
                        <stop offset={0.7422} style={{ stopColor: "#FF902B" }} />
                        <stop offset={0.7461} style={{ stopColor: "#FF912B" }} />
                        <stop offset={0.75} style={{ stopColor: "#FF912C" }} />
                        <stop offset={0.7539} style={{ stopColor: "#FF922C" }} />
                        <stop offset={0.7578} style={{ stopColor: "#FF932D" }} />
                        <stop offset={0.7617} style={{ stopColor: "#FF942D" }} />
                        <stop offset={0.7656} style={{ stopColor: "#FF952E" }} />
                        <stop offset={0.7695} style={{ stopColor: "#FF962E" }} />
                        <stop offset={0.7734} style={{ stopColor: "#FF962F" }} />
                        <stop offset={0.7773} style={{ stopColor: "#FF972F" }} />
                        <stop offset={0.7812} style={{ stopColor: "#FF9830" }} />
                        <stop offset={0.7852} style={{ stopColor: "#FF9930" }} />
                        <stop offset={0.7891} style={{ stopColor: "#FF9A31" }} />
                        <stop offset={0.793} style={{ stopColor: "#FF9A31" }} />
                        <stop offset={0.7969} style={{ stopColor: "#FF9B32" }} />
                        <stop offset={0.8008} style={{ stopColor: "#FF9C32" }} />
                        <stop offset={0.8047} style={{ stopColor: "#FF9D33" }} />
                        <stop offset={0.8086} style={{ stopColor: "#FF9E33" }} />
                        <stop offset={0.8125} style={{ stopColor: "#FF9F33" }} />
                        <stop offset={0.8164} style={{ stopColor: "#FF9F34" }} />
                        <stop offset={0.8203} style={{ stopColor: "#FFA034" }} />
                        <stop offset={0.8242} style={{ stopColor: "#FFA135" }} />
                        <stop offset={0.8281} style={{ stopColor: "#FFA235" }} />
                        <stop offset={0.832} style={{ stopColor: "#FFA336" }} />
                        <stop offset={0.8359} style={{ stopColor: "#FFA336" }} />
                        <stop offset={0.8398} style={{ stopColor: "#FFA437" }} />
                        <stop offset={0.8438} style={{ stopColor: "#FFA537" }} />
                        <stop offset={0.8477} style={{ stopColor: "#FFA638" }} />
                        <stop offset={0.8516} style={{ stopColor: "#FFA738" }} />
                        <stop offset={0.8555} style={{ stopColor: "#FFA739" }} />
                        <stop offset={0.8594} style={{ stopColor: "#FFA839" }} />
                        <stop offset={0.8633} style={{ stopColor: "#FFA93A" }} />
                        <stop offset={0.8672} style={{ stopColor: "#FFAA3A" }} />
                        <stop offset={0.8711} style={{ stopColor: "#FFAB3B" }} />
                        <stop offset={0.875} style={{ stopColor: "#FFAC3B" }} />
                        <stop offset={0.8789} style={{ stopColor: "#FFAC3C" }} />
                        <stop offset={0.8828} style={{ stopColor: "#FFAD3C" }} />
                        <stop offset={0.8867} style={{ stopColor: "#FFAE3D" }} />
                        <stop offset={0.8906} style={{ stopColor: "#FFAF3D" }} />
                        <stop offset={0.8945} style={{ stopColor: "#FFB03E" }} />
                        <stop offset={0.8984} style={{ stopColor: "#FFB03E" }} />
                        <stop offset={0.9023} style={{ stopColor: "#FFB13F" }} />
                        <stop offset={0.9062} style={{ stopColor: "#FFB23F" }} />
                        <stop offset={0.9102} style={{ stopColor: "#FFB33F" }} />
                        <stop offset={0.9141} style={{ stopColor: "#FFB440" }} />
                        <stop offset={0.918} style={{ stopColor: "#FFB540" }} />
                        <stop offset={0.9219} style={{ stopColor: "#FFB541" }} />
                        <stop offset={0.9258} style={{ stopColor: "#FFB641" }} />
                        <stop offset={0.9297} style={{ stopColor: "#FFB742" }} />
                        <stop offset={0.9336} style={{ stopColor: "#FFB842" }} />
                        <stop offset={0.9375} style={{ stopColor: "#FFB943" }} />
                        <stop offset={0.9414} style={{ stopColor: "#FFB943" }} />
                        <stop offset={0.9453} style={{ stopColor: "#FFBA44" }} />
                        <stop offset={0.9492} style={{ stopColor: "#FFBB44" }} />
                        <stop offset={0.9531} style={{ stopColor: "#FFBC45" }} />
                        <stop offset={0.957} style={{ stopColor: "#FFBD45" }} />
                        <stop offset={0.9609} style={{ stopColor: "#FFBD46" }} />
                        <stop offset={0.9648} style={{ stopColor: "#FFBE46" }} />
                        <stop offset={0.9688} style={{ stopColor: "#FFBF47" }} />
                        <stop offset={0.9727} style={{ stopColor: "#FFC047" }} />
                        <stop offset={0.9766} style={{ stopColor: "#FFC148" }} />
                        <stop offset={0.9805} style={{ stopColor: "#FFC248" }} />
                        <stop offset={0.9844} style={{ stopColor: "#FFC249" }} />
                        <stop offset={0.9883} style={{ stopColor: "#FFC349" }} />
                        <stop offset={0.9922} style={{ stopColor: "#FFC44A" }} />
                        <stop offset={0.9961} style={{ stopColor: "#FFC54A" }} />
                        <stop offset={1} style={{ stopColor: "#FFC64B" }} />
                    </linearGradient>
                    <path style={{ fill: "url(#SVGID_00000121238017043144745250000008116791160412006079_)" }} d="M0,0.1v122h133.4V0.1H0z" />
                </g>
            </g>
        </g>
        <g fill={fill}>
            <g transform="translate(115.912299, 187.103741)">
                <path d="M67.6-143.3l-0.9,3.2c-2.9-2.6-6.8-4.1-11.2-4.1c-10.2,0-17.7,7.6-17.7,17.9c0,10.2,7.6,17.9,17.7,17.9 c4.3,0,8.1-1.5,11-4.1l0.8,3.1h7.1v-33.8H67.6z M56.3-117.1c-5.3,0-9.2-4-9.2-9.3c0-5.3,3.9-9.3,9.2-9.3c5.3,0,9.2,4,9.2,9.3 C65.5-121,61.6-117.1,56.3-117.1z" />
            </g>
            <g transform="translate(148.340629, 187.103741)">
                <path d="M66.3-108.4c9.6,0,15.9-6.1,15.9-15.3v-19.6H73v18.6c0,4.8-2.5,7.7-6.8,7.7c-4.2,0-6.8-2.8-6.8-7.7v-18.6 h-9.2v19.6C50.3-114.6,56.7-108.4,66.3-108.4z" />
            </g>
            <g transform="translate(178.090087, 187.103741)">
                <path d="M85.6-155.4v14c-2.6-1.8-5.8-2.8-9.3-2.8c-10.3,0-17.8,7.6-17.8,17.9c0,10.2,7.5,17.9,17.8,17.9 c4.1,0,7.8-1.4,10.6-3.8l1.1,2.8h6.8v-46.1H85.6z M77.1-117c-5.3,0-9.2-4-9.2-9.3c0-5.3,3.9-9.3,9.2-9.3c5.3,0,9.2,4,9.2,9.3 C86.3-121,82.4-117,77.1-117z" />
            </g>
            <g transform="translate(210.18943, 187.103741)">
                <path d="M71.4-147.8h9.1v-8.5h-9.1V-147.8z M71.4-109.4h9.2v-33.8h-9.2V-109.4z" />
            </g>
            <g transform="translate(223.630736, 187.103741)">
                <path d="M92-108.4c10.5,0,18.3-7.7,18.3-17.9c0-10.2-7.8-17.9-18.3-17.9c-10.5,0-18.3,7.6-18.3,17.9 C73.7-116.1,81.5-108.4,92-108.4z M92-117.1c-5.3,0-9-3.8-9-9.3c0-5.5,3.8-9.3,9-9.3s9,3.8,9,9.3C101-120.8,97.2-117.1,92-117.1z " />
            </g>
            <g transform="translate(254.320151, 187.103741)">
                <path d="M104.6-144.2c-4.2,0-8,1.5-10.8,4.1l-1.6-3.1h-6v46.1h9.2v-14c2.6,1.8,5.8,2.9,9.3,2.9 c10.2,0,17.7-7.7,17.7-18C122.3-136.6,114.8-144.2,104.6-144.2z M103.8-117.1c-5.3,0-9.2-3.9-9.2-9.3c0-5.3,3.9-9.3,9.2-9.3 s9.2,4,9.2,9.3C113-121,109.2-117.1,103.8-117.1z" />
            </g>
            <g transform="translate(286.37249, 187.103741)">
                <path d="M116.2-144c-4.1,0-7.6,1.5-10.2,3.9v-15.4h-9.2v46h9.2v-17.7c0-5.5,3-8.8,7.6-8.8c4.1,0,5.9,2.5,5.9,7.6v19 h9.2V-130C128.6-138.6,123.9-144,116.2-144z" />
            </g>
            <g transform="translate(316.497939, 187.103741)">
                <path d="M106.9-147.8h9.1v-8.5h-9.1V-147.8z M106.9-109.4h9.2v-33.8h-9.2V-109.4z" />
            </g>
            <g transform="translate(329.939246, 187.103741)">
                <path d="M111.4-109.4h9.2v-46h-9.2V-109.4z" />
            </g>
            <g transform="translate(343.380552, 187.103741)">
                <path d="M148.7-126.4c0-9.8-7.1-17.8-17.6-17.8c-10,0-17.6,7.7-17.6,17.9c0,10.2,7.6,17.9,17.6,17.9 c7.9,0,14.4-4.7,16.8-12.1h-9.6c-1.4,2.4-4,3.9-7.2,3.9c-4.5,0-7.5-2.6-8.3-7.2h25.6C148.6-124.7,148.7-125.5,148.7-126.4z  M131.1-136.4c4.1,0,7.1,2.3,8.4,6.4h-16.4C124.2-134,127.1-136.4,131.1-136.4z" />
            </g>
        </g>
    </svg>
);

export default SVGComponent;